import script from "./NoticeRoute.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticeRoute.vue?vue&type=script&setup=true&lang=js"

import "./NoticeRoute.vue?vue&type=style&index=0&id=55510933&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55510933"]])

export default __exports__